import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "user-details-section" }
const _hoisted_2 = {
  key: 0,
  class: "results"
}
const _hoisted_3 = { class: "table-content" }
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = { class: "email inputs" }
const _hoisted_6 = { class: "inputs" }
const _hoisted_7 = { class: "inputs" }
const _hoisted_8 = { class: "inputs" }
const _hoisted_9 = { class: "grid-2" }
const _hoisted_10 = { class: "inputs" }
const _hoisted_11 = { class: "inputs" }
const _hoisted_12 = { class: "inputs" }
const _hoisted_13 = { class: "inputs" }
const _hoisted_14 = { class: "inputs" }
const _hoisted_15 = { class: "inputs" }
const _hoisted_16 = { class: "button-group" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderDots = _resolveComponent("LoaderDots")!
  const _component_Notes = _resolveComponent("Notes")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.user)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "result-title" }, "User Details", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("form", {
                id: "details-form",
                class: "grid-1",
                autocomplete: "off",
                onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateUserDetails && _ctx.updateUserDetails(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { for: "email" }, "Email Address", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      id: "email",
                      name: "email",
                      placeholder: "Email Address",
                      pattern: "^[a-zA-Z0-9_.]+@[a-zA-Z0-9_.]+\\.[a-zA-Z0-9_.]+$",
                      minlength: "7",
                      maxlength: "320",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.emailAddress) = $event)),
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.user.emailAddress,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { for: "first_name" }, "First Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "first_name",
                      name: "first_name",
                      placeholder: "First Name",
                      pattern: "^[A-Za-z-'-]+$",
                      minlength: "1",
                      maxlength: "30",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.firstName) = $event)),
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.user.firstName,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { for: "last_name" }, "Last Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "last_name",
                      name: "last_name",
                      placeholder: "Last Name",
                      pattern: "^[A-Za-z-'-]+$",
                      minlength: "1",
                      maxlength: "30",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.lastName) = $event)),
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.user.lastName,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { for: "year_of_birth" }, "Year Of Birth", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "year_of_birth",
                      name: "year_of_birth",
                      placeholder: "Year of Birth",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.yearOfBirth) = $event)),
                      readonly: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.user.yearOfBirth,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", { for: "phone" }, "Phone Number", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      id: "phone",
                      name: "phone",
                      placeholder: "Phone Number",
                      pattern: "^\\+?[0-9\\s\\-\\(\\)]{7,21}$",
                      inputmode: "numeric",
                      minlength: "7",
                      maxlength: "21",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.phoneNumber) = $event)),
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.user.phoneNumber,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", { for: "address1" }, "Address1", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "address1",
                      name: "address1",
                      placeholder: "Address1",
                      maxlength: "100",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.address1) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.user.address1,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { for: "address2" }, "Address2", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "address2",
                      name: "address2",
                      placeholder: "Address2",
                      maxlength: "100",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.address2) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.user.address2,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", { for: "address3" }, "Address3", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "address3",
                      name: "address3",
                      placeholder: "Address3",
                      maxlength: "100",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.address3) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.user.address3,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { for: "postcode" }, "Postcode", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "postcode",
                      name: "postcode",
                      placeholder: "postcode",
                      maxlength: "10",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.postcode) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.user.postcode,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", { for: "town_or_city" }, "TownOrCity", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "town_or_city",
                      name: "town_or_city",
                      placeholder: "Town Or City",
                      maxlength: "50",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.townOrCity) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.user.townOrCity,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ])
              ], 32),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  disabled: _ctx.isSubmittingUpdateDetails,
                  class: "btn",
                  type: "submit",
                  form: "details-form"
                }, [
                  (!_ctx.isSubmittingUpdateDetails)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Update Details"))
                    : _createCommentVNode("", true),
                  (_ctx.isSubmittingUpdateDetails)
                    ? (_openBlock(), _createBlock(_component_LoaderDots, { key: 1 }))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_17),
                _createElementVNode("button", {
                  disabled: _ctx.isSubmittingPasswordReset,
                  class: "btn",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.sendResetPasswordEmail && _ctx.sendResetPasswordEmail(...args)))
                }, [
                  (!_ctx.isSubmittingPasswordReset)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Reset Password"))
                    : _createCommentVNode("", true),
                  (_ctx.isSubmittingPasswordReset)
                    ? (_openBlock(), _createBlock(_component_LoaderDots, { key: 1 }))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_19),
                _createElementVNode("button", {
                  disabled: _ctx.isGettingSetPasswordLink,
                  class: "btn",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.getSetPasswordLink && _ctx.getSetPasswordLink(...args)))
                }, [
                  (!_ctx.isGettingSetPasswordLink)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Get Set Password Link"))
                    : _createCommentVNode("", true),
                  (_ctx.isGettingSetPasswordLink)
                    ? (_openBlock(), _createBlock(_component_LoaderDots, { key: 1 }))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_21)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Notes)
  ], 64))
}